export default __webpack_public_path__ + "static/media/targetOff.e4805c19.png";